'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuex = require('vuex');

var _Step = require('./Step1');

var _Step2 = _interopRequireDefault(_Step);

var _Step3 = require('./Step2');

var _Step4 = _interopRequireDefault(_Step3);

var _Step5 = require('./Step3');

var _Step6 = _interopRequireDefault(_Step5);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: "Options",
  components: {
    Step1: _Step2.default,
    Step2: _Step4.default,
    Step3: _Step6.default
  },
  computed: Object.assign({}, (0, _vuex.mapState)({
    step: function step(state) {
      return state.prescription.step;
    },
    activePrescription: function activePrescription(state) {
      return state.prescription.activePrescription;
    },
    meta: function meta(state) {
      return state.prescription.meta;
    },
    options: function options(state) {
      return state.prescription.options;
    },
    cms: function cms(state) {
      return state.prescription.cms.global;
    }
  }), {
    errorDivFocus: function errorDivFocus() {
      return this.hasErrors ? 0 : -1;
    },
    cancelDivFocus: function cancelDivFocus() {
      return this.showCancelModal ? 0 : -1;
    }
  }),
  data: function data() {
    return {
      hasErrors: false,
      errorMessage: '',
      showCancelModal: false
    };
  },

  methods: Object.assign({}, (0, _vuex.mapMutations)(['setActiveLenses', 'setPrescription', 'setFinalLens', 'setStep', 'hideModule', 'setFinalVariant', 'setFrameOptions']), {
    clearForm: function clearForm() {
      var resetPrescriptionObject = {};
      var resetOptionsObject = {};

      resetPrescriptionObject.id = '', resetPrescriptionObject.prescriptionSet = false, resetPrescriptionObject.newPrescription = true, resetPrescriptionObject.date = '', resetPrescriptionObject.store = '', resetPrescriptionObject.type = '', resetPrescriptionObject.left = { sph: '', cyl: '', axis: '', add: '', ipd: '', ph: '' }, resetPrescriptionObject.right = { sph: '', cyl: '', axis: '', add: '', ipd: '', ph: '' };

      resetOptionsObject.step1 = { name: 'Vision:', cost: 0 };
      resetOptionsObject.step2 = { name: 'Lens Type:', cost: 0 };
      resetOptionsObject.step3 = { name: 'Lens Option:', cost: 0 };

      this.setPrescription(resetPrescriptionObject);
      this.setActiveLenses([]);
      this.setFinalLens({});
      this.setFinalVariant({});
      this.setFrameOptions(resetOptionsObject);
    },
    showCancelConfirm: function showCancelConfirm() {
      this.showCancelModal = true;
      this.$refs.cancelconfirm.focus();
    },
    hideCancelConfirm: function hideCancelConfirm() {
      this.showCancelModal = false;
    },
    clearDataAndForm: function clearDataAndForm() {
      this.hideCancelConfirm();
      this.clearForm();

      document.body.classList.remove('customize-prescription-popup');
      if (document.body.classList.contains('temporary-disable-top-bar')) {
        document.body.classList.remove('temporary-disable-top-bar', 'disable-top-bar');
        document.querySelector('.js-top-bar').style.display = 'block';
      }
      this.hideModule();
      this.setStep(1);
    },
    displayError: function displayError(generalError) {
      this.errorMessage = generalError;
      this.hasErrors = true;
      this.$refs.errorwrapper.focus();
    },
    closeErrorModule: function closeErrorModule() {
      this.hasErrors = false;
      this.errorMessage = '';
      document.querySelector('#prescriptionForm .error').focus();
    }
  })
};